// Growth Systems - job cards (step-by-step instructions), keyed by job code. (M cards)
// A step is { text, tag }; a red STOP bar is { stop }. Loaded automatically by constants/jobCards.js.

export const division = "Growth Systems";

export const cards = {
  M1: {
    title: "Fractional CMO / advisory engagement",
    before: [
      "Agreed scope",
      "One named client counterpart",
    ],
    steps: [
      { text: "Write what the founder advises on, what our team delivers, and what is not included", tag: "Scope note" },
      { text: "Put the sessions in the calendar as a repeating series", tag: "Calendar set" },
      { text: "Write down where the client is today: performance, spend, team, tools, pipeline", tag: "Baseline" },
      { text: "Open a decisions log: every recommendation, what was decided, who owns it, the date", tag: "Decisions log" },
      { text: "Founder runs the session. The Division Lead writes the notes the SAME DAY, not the founder", tag: "Notes" },
      { text: "Between sessions, our team does the work. The founder advises, we deliver", tag: "Delivery" },
      { text: "Build the monthly pack FROM the channel reports. Do not write it from scratch", tag: "Pack" },
      { stop: "Founder reviews the pack before the client sees it" },
      { text: "Requests that reach the founder between sessions go to the Division Lead unless they are strategic", tag: "Routed" },
    ],
    finishedWhen: "Decisions logged, pack delivered, session held, next month agreed.",
  },
  M2: {
    title: "Discovery and marketing audit",
    before: [
      "Access to their data and their team",
    ],
    steps: [
      { text: "Understand the business: how they make money, the sales process, deal size, how long it takes", tag: "Context" },
      { text: "Interview the founder, sales, marketing, and if possible two customers. Customers say things the internal team cannot.", tag: "Interviews" },
      { text: "Audit what runs today, what it costs, what it produces", tag: "Current state" },
      { text: "Check the tools: what they pay for and never use, where data breaks", tag: "Tool audit" },
      { text: "Check how work actually gets from idea to live, and where it gets stuck", tag: "Process audit" },
      { text: "Sort findings into quick wins and structural fixes", tag: "Prioritised" },
      { stop: "Founder reviews" },
      { stop: "Client agrees the findings in a live session. An audit sent as a PDF gets skimmed" },
    ],
    finishedWhen: "Audit delivered live, priorities agreed, and it feeds the roadmap.",
  },
  M3: {
    title: "Positioning and value proposition",
    before: [
      "Discovery done or equivalent input",
    ],
    steps: [
      { text: "Do this before any copy is written. Everything this division writes comes from it", tag: "" },
      { text: "Work out what buyers actually compare them against, which is often not who they think", tag: "Category" },
      { text: "Sharpen who they serve, and say clearly who they do NOT", tag: "ICP" },
      { text: "Write the problem in the CUSTOMER'S words, taken from interviews", tag: "Problem" },
      { text: "Write what makes them different, and only keep what can be PROVED", tag: "Differentiation" },
      { text: "Anything that cannot be proved comes out now, not defended later", tag: "Clean" },
      { text: "Write the one line, the three pillars, and the proof under each", tag: "Messaging" },
      { text: "Write the common objections and the answer to each", tag: "Objections" },
      { text: "Test it with their sales team, and a customer if you can", tag: "Tested" },
      { stop: "Client approves" },
      { text: "Send it to EVERY division. It is the source for all client copy", tag: "Distributed" },
    ],
    finishedWhen: "Signed positioning, shared with every division, cited in every brief after it.",
  },
  M4: {
    title: "SEO strategy",
    before: [
      "Audit delivered",
      "Positioning approved",
    ],
    steps: [
      { text: "Write down what you are assuming and what limits you", tag: "Assumptions" },
      { text: "Research the keywords and group them by what the searcher actually wants", tag: "Keyword map" },
      { text: "Compare with competitors: what do they rank for that the client does not", tag: "Gap analysis" },
      { text: "Decide the topics the content will keep returning to", tag: "Topics" },
      { text: "Write the plan in phases with real dates", tag: "Roadmap" },
      { text: "Write the targets AND today's numbers next to them", tag: "Targets" },
      { text: "Check the plan fits the hours we are actually paid for. If it does not fit, have that conversation NOW, not in month three.", tag: "Capacity ok" },
      { stop: "Founders check, then the client approves" },
    ],
    finishedWhen: "Approved strategy with dates, targets, today's numbers, and a capacity check.",
  },
  M5: {
    title: "Fixing technical SEO problems",
    before: [
      "Approved list of what to fix",
      "Tech and Automation booked with 5 days notice",
    ],
    steps: [
      { text: "Take the fixes from the audit, most serious first", tag: "Fix list" },
      { text: "Write down how things look BEFORE you change anything", tag: "Baseline" },
      { text: "Send the work to Tech and Automation with 5 working days notice", tag: "Raised" },
      { text: "For anything risky, agree a rollback plan first, and never ship on a Friday afternoon", tag: "Rollback ready" },
      { text: "After the change, check the thing you fixed AND that nothing else broke", tag: "Verified" },
      { text: "Check again at 7 days and 30 days. Some problems show up late", tag: "Monitored" },
    ],
    finishedWhen: "Fix verified, nothing else broken, and checked again at 7 and 30 days.",
  },
  M6: {
    title: "Getting other sites to link to ours",
    before: [
      "Approved plan with the target pages",
    ],
    steps: [
      { text: "Join the communities properly first and be genuinely useful", tag: "Presence" },
      { text: "Only then share anything of ours, and only where it actually helps", tag: "Contributions" },
      { text: "Build a list of sites worth being on: real audience, real editors, not spam", tag: "Prospect list" },
      { text: "Never pay for links pretending they are editorial, and never use link farms, mass link swaps or comment spam", tag: "" },
      { text: "If a placement is paid, say so internally and to the client, and treat it as advertising", tag: "Disclosed" },
      { text: "Track every placement: site, page, date, link, quality", tag: "Tracker" },
      { text: "Every quarter, check the links are still there and still count", tag: "Retention check" },
    ],
    finishedWhen: "Placements tracked, quality checked, and nothing on the never list has been used.",
  },
  M7: {
    title: "Refreshing old pages",
    before: [
      "A page that used to perform and no longer does",
    ],
    steps: [
      { text: "Work out WHY it dropped before touching it", tag: "Diagnosis" },
      { text: "Decide: update it, expand it, merge it into another page, retarget it, or remove it", tag: "Decision" },
      { text: "Write down its numbers today so you can tell if the refresh worked", tag: "Baseline" },
      { text: "Update it with current, sourced figures", tag: "Updated" },
      { text: "If you merged or removed it, set up the redirect and fix the internal links", tag: "Redirects" },
      { text: "Check at 30 and 90 days against the baseline", tag: "Measured" },
    ],
    finishedWhen: "Refresh done with a baseline captured, and measured at 30 and 90 days.",
  },
  M8: {
    title: "Being quoted in AI answers",
    before: [
      "The fixed question set from the audit",
    ],
    steps: [
      { text: "Use the SAME questions every month. Changing them makes the trend meaningless", tag: "Same set" },
      { text: "Record whether an AI answer appeared, whether the client was quoted, and which page", tag: "Results" },
      { text: "Record when a COMPETITOR was quoted instead. That is the useful signal", tag: "Competitor data" },
      { text: "Check AI crawlers can still reach the site", tag: "Access ok" },
      { text: "Put the trend in the monthly report next to the rankings", tag: "Reported" },
    ],
    finishedWhen: "Same questions tested, trend recorded, and it is in the monthly report.",
  },
  M9: {
    title: "LinkedIn strategy for a person",
    before: [
      "Approved positioning",
      "The person is available for a session",
    ],
    steps: [
      { text: "Decide: personal profile, company page, or both, and which comes first", tag: "Focus" },
      { text: "Agree the point of view. What do they believe that others in their field do not", tag: "POV" },
      { text: "AGREE HOW THE RAW MATERIAL WILL COME OUT OF THEIR HEAD", tag: "Source agreed" },
      { text: "A weekly 30 minute call, voice notes, or existing recordings. Something concrete. Without this, the retainer stalls in week three. It is the most common failure in this service.", tag: "Method" },
      { text: "Agree 3 to 5 topics they will keep returning to", tag: "Themes" },
      { text: "Agree formats, how often, and what good looks like in numbers", tag: "Cadence" },
      { text: "Write voice notes so a writer can sound like them", tag: "Voice guide" },
      { stop: "Founders check, then the client approves" },
      { text: "Hand the plan to the social team for their calendar", tag: "Handed over" },
    ],
    finishedWhen: "Signed strategy, and a concrete agreed way of getting raw material every week.",
  },
  M10: {
    title: "Improving a LinkedIn profile",
    before: [
      "Approved positioning",
      "Written permission to edit, or we only advise",
    ],
    steps: [
      { text: "Screenshot EVERY section before you change anything. This is your only way back", tag: "Before shots" },
      { text: "Confirm in writing whether we edit directly or only send recommendations", tag: "Permission clear" },
      { text: "Rewrite the headline to say what they DO for people, not their job title", tag: "Headline" },
      { text: "Rewrite the About section: who they help, how, the proof, what to do next", tag: "About" },
      { text: "Pin the best proof to the Featured section", tag: "Featured" },
      { text: "Tighten the experience entries to outcomes, not duties", tag: "Experience" },
      { text: "Reorder the skills to match the positioning, and tidy the profile link", tag: "Tidied" },
      { stop: "Client approves the before and after, before ANY live change" },
    ],
    finishedWhen: "Profile updated with approval, and the before screenshots are saved.",
  },
  M11: {
    title: "LinkedIn outbound",
    before: [
      "Profile already improved",
      "Client understands the account risk",
    ],
    steps: [
      { text: "Improve the profile FIRST. Outbound from a weak profile does not work", tag: "Profile done" },
      { text: "Tell the client in writing that automation can get an account restricted, and agree who carries that risk", tag: "Risk agreed" },
      { text: "If the account has been quiet, use it normally by hand for a while first. Automation on a dormant account is the fastest way to get it restricted.", tag: "Warmed" },
      { text: "Keep existing connections separate from cold people. They need a different message and no connect request", tag: "Segmented" },
      { stop: "Project lead (if named), then Division Lead, then founders approve the message sequence before it is first used" },
      { text: "Build the list, dedupe against the email list so nobody gets both in the same week", tag: "List" },
      { text: "Launch slowly and watch the account for warnings", tag: "Live" },
      { text: "Replies follow card G8, the same as email", tag: "Handled" },
    ],
    finishedWhen: "Running, with the risk agreed in writing and replies handled to the same standard as email.",
  },
  M12: {
    title: "Named account programme (ABM)",
    before: [
      "High deal value and a long sales cycle",
      "The client's sales team will actually take part",
    ],
    steps: [
      { text: "Check this is the right approach: big deals, few buyers, several people decide, sales will engage. If the sales team will not take part, this is just expensive outbound. Say so.", tag: "Fit confirmed" },
      { text: "Pick the depth: 5 to 15 fully bespoke, 20 to 60 grouped, or 100 to 500 light", tag: "Depth chosen" },
      { text: "Agree the account list WITH the client's sales team, not on our own", tag: "Account list" },
      { text: "Research each account: who decides, what is changing there, how we get in", tag: "Research" },
      { text: "Write the message per group, built from the positioning", tag: "Messages" },
      { text: "Agree exactly when marketing hands to sales, and who does what", tag: "Handover agreed" },
      { text: "Report BY ACCOUNT: engagement, meetings, pipeline. Never by impressions", tag: "Reporting" },
    ],
    finishedWhen: "Running with sales alignment agreed, and reported account by account.",
  },
  M13: {
    title: "SDR retainer",
    before: [
      "Approved targeting, sequences and infrastructure",
      "A written meeting definition",
    ],
    steps: [
      { stop: "The client and the founders agree in writing what counts as a meeting, before anything runs" },
      { text: "Our position: a HELD meeting, where the right person actually turns up. Billing on booked meetings pushes the no-show risk onto the client, and they notice by month two.", tag: "Definition" },
      { text: "Brief the SDR properly: the offer, who to target, objections, proof, the word list", tag: "Onboarded" },
      { text: "Set the daily rhythm: prospecting, sending, replies, follow-up", tag: "Rhythm" },
      { text: "Weekly one to one with the Division Lead", tag: "Weekly" },
      { text: "Track meetings booked AND meetings held, as separate numbers", tag: "Both tracked" },
      { text: "Ask the client monthly whether the meetings were any good", tag: "Quality check" },
    ],
    finishedWhen: "Meeting definition agreed in writing, both numbers tracked, and quality checked monthly.",
  },
  M14: {
    title: "Sales enablement asset",
    before: [
      "Approved positioning",
      "Access to the client's sales team",
    ],
    steps: [
      { text: "TALK TO THE SALES TEAM FIRST. Built without them, it will not be used. That is the normal outcome for this deliverable, so do not skip it.", tag: "Input" },
      { text: "Find the real gap: objections, competitor comparison, pricing talk, discovery questions, follow-ups", tag: "Gap" },
      { text: "Build it from the positioning, the proof, and REAL objections", tag: "Asset" },
      { text: "Ask the social team to design it if the client will show it to people", tag: "Designed" },
      { text: "Test it with ONE salesperson before rolling it out", tag: "Tested" },
      { text: "Roll it out with a short walkthrough. Handed over silently, it will sit unused", tag: "Rolled out" },
      { text: "Check after 60 days whether it is actually being used", tag: "Reviewed" },
    ],
    finishedWhen: "In use by the sales team, and reviewed after 60 days.",
  },
  M15: {
    title: "Email programme",
    before: [
      "Approved positioning",
      "Access to their sending tool and list",
    ],
    steps: [
      { text: "Check the health of the list before sending anything", tag: "List health" },
      { text: "If the list is old or cold, clean it and re-engage BEFORE a big send. Sending to a stale list damages the domain for everything else.", tag: "Cleaned" },
      { text: "Split the list into groups that should get different things", tag: "Segments" },
      { text: "Decide the types: newsletter, nurture, promotional, lifecycle, and how often", tag: "Programme" },
      { text: "Write the goals with today's numbers next to them", tag: "Targets" },
      { text: "Write the copy. Ask the social team for design 5 working days ahead", tag: "Copy + design" },
      { text: "Test how it looks on desktop, phone, dark mode and one office inbox BEFORE approval", tag: "Render tested" },
      { text: "Honour every unsubscribe immediately", tag: "Suppressed" },
    ],
    finishedWhen: "Programme running, every send render-tested, and unsubscribes honoured immediately.",
  },
  M16: {
    title: "Automatic email sequences",
    before: [
      "Approved email programme",
    ],
    steps: [
      { text: "Map it out before building: what starts it, the emails, the timing, the branches, what ENDS it", tag: "Flow map" },
      { text: "The exit conditions matter most. A flow with no exit keeps emailing people who already bought", tag: "Exits set" },
      { text: "Build it", tag: "Built" },
      { text: "Test it end to end with a REAL record. Walk through it as if you were the customer", tag: "Tested" },
      { text: "Turn it on", tag: "Live" },
      { text: "Review every live flow once a quarter. Automatic sequences go stale and keep sending", tag: "Quarterly review" },
    ],
    finishedWhen: "Flow tested end to end with a real record, and booked for quarterly review.",
  },
  M17: {
    title: "Case study",
    before: [
      "The customer has agreed to take part",
    ],
    steps: [
      { text: "Agree UP FRONT where it can be used, including in paid ads. Getting that permission later is much harder.", tag: "Usage agreed" },
      { text: "Send the questions ahead so they come prepared", tag: "Questions sent" },
      { text: "Record the interview", tag: "Recording" },
      { text: "Get the real numbers and check them with the client. No rounding up", tag: "Verified" },
      { text: "Write it: the situation, the problem, what we did, the result, and their own words", tag: "Draft" },
      { stop: "BOTH the client and the customer approve. The customer can veto how they are described" },
      { text: "Ask the social team to design it", tag: "Designed" },
    ],
    finishedWhen: "Approved by both, designed, and usable in the places agreed at the start.",
  },
  M18: {
    title: "Website content and structure",
    before: [
      "Approved positioning",
      "Signed website scope",
    ],
    steps: [
      { text: "Plan the pages and how they connect, BEFORE any design", tag: "Sitemap" },
      { text: "Decide what each page is for and what someone should do on it", tag: "Page purpose" },
      { text: "Map the search terms to the pages", tag: "Keyword map" },
      { text: "Write a brief per page: who reads it, the message, the proof, the action", tag: "Page briefs" },
      { text: "Apply the basics: one clear action per page, proof near the ask, short forms", tag: "CRO applied" },
      { text: "Write the copy from the approved positioning", tag: "Copy" },
      { text: "Fill the proof list: every claim, figure, name and logo, with its source", tag: "Proof list" },
      { stop: "Client approves the copy page by page. Then card G12 takes over" },
    ],
    finishedWhen: "Copy approved page by page, and the proof list is complete before building starts.",
  },
  M19: {
    title: "Website changes after launch",
    before: [
      "A live site we look after",
    ],
    steps: [
      { text: "Small copy changes, new sections, new images, improving the page", tag: "Change" },
      { text: "Use the design system that is already there. No new colours or components without approval", tag: "Consistent" },
      { text: "Anything structural goes to the Division Lead first", tag: "Approved" },
      { text: "If a client wants changes every week, it is a monthly retainer with set hours, not an open door", tag: "Scoped" },
    ],
    finishedWhen: "Change made within the existing design system and logged.",
  },
};
